import Browser from 'browser';
import YouTubeIframe from 'youtube-iframe';
import Logger from '../utils/logger';

const stateNames = {
  '-1': 'ready',    // READY
  0: 'ended',     // YT.Player.ENDED
  1: 'playing',     // YT.PlayerState.PLAYING
  2: 'paused',    // YT.PlayerState.PAUSED
  3: 'buffering',   // YT.PlayerState.BUFFERING
  5: 'queued',     // YT.PlayerState.CUED
};

export default class YouTubePlayer {
  static display(elementId, videoId, options = {}) {
    Logger.debug('Displaying YouTube video on #', elementId, 'with videoId', videoId);

    if (Browser.getWindow().YT && Browser.getWindow().YT.Player) {
      this.playVideo(elementId, videoId, options);
    } else {
      YouTubeIframe.load(() => {
        Logger.debug('Instantiating a YT Player object');

        this.playVideo(elementId, videoId, options);
      });
    }
  }

  static playVideo(elementId, videoId, options) {
    /* eslint-disable no-new */
    const YT = Browser.getWindow().YT;

    new YT.Player(elementId, {
      /* eslint-enable no-new */
      videoId,
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay: 1,
      },
      events: {
        onStateChange: event => YouTubePlayer.onStateChange(event, options),
      },
    });
  }

  static onStateChange(event, options = {}) {
    const state = stateNames[event.data.toString()];
    const currentTime = event.target.getCurrentTime();

    switch (state) {
      case 'ended':
        if (options.onEnd) {
          options.onEnd(currentTime);
        }
        break;
      case 'playing':
        if (options.onPlay) {
          options.onPlay(currentTime);
        }
        break;
      case 'paused':
        if (options.onPause) {
          options.onPause(currentTime);
        }
        break;
      case 'buffering':
      case 'queued':
      case 'ready':
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/youtube-player.js